module.exports = __webpack_public_path__ + "img/removecand.4d36729f.svg";